var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myFamily wh100"},[_c('navBar',{attrs:{"title":"我的家人","leftArrowFlag":true}}),_c('div',{staticClass:"content"},[_c('div',{directives:[{name:"drag",rawName:"v-drag"}],staticClass:"tree_box"},[_c('TreeChart',{attrs:{"json":_vm.treeData},on:{"click-node":_vm.clickNode}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }